import PropTypes from 'prop-types';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * @deprecated
  * No need to provide any skin. Simply use an Icon in button
  */
  skin: deprecatedProp(PropTypes.oneOf(['standard', 'searchbar']), 'No need to provide any skin. Simply use an Icon in button'),

  /**
  * Position of the button.
  * Available options: 'left', 'right'
  */
  buttonPosition: PropTypes.oneOf(['left', 'right'])
};
var TextInputWithButtonInset = createComponent({
  displayName: 'TextInputWithButtonInset',
  root: 'div',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classesSet = new Set(['swan-vanilla-ignore', 'swan-input-with-button-inset']);
      if (props.buttonPosition && props.buttonPosition === 'left') classesSet.add("swan-input-with-button-left");
      if (props.skin && props.skin !== 'standard') classesSet.add("swan-input-with-button-skin-".concat(props.skin));
      return classesSet;
    }
  }
});
export { TextInputWithButtonInset };